export default __webpack_public_path__ + "static/01-138cb577d819cd58c1e4e1d6028b0922.mp4";